import React, { useRef, useState } from "react";
import "./Portfolio.css";
import emailjs from "@emailjs/browser";
import { FaGithub, FaLinkedin, FaBars, FaTimes } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import OtaPharm from "../Media/Otapharm.png";
import Innohub from "../Media/Innohub.png";
import Dealer from "../Media/Dealer.PNG";
import Leart from "../Media/Leart.png";

const skills = [
  { title: "HTML/CSS", desc: "Semantic markup and modern styling.", icon: "</>" },
  { title: "JavaScript", desc: "ES6+ and modern frontend logic.", icon: "JS" },
  { title: "React", desc: "Component-based modern web apps.", icon: "⚛" },
  { title: "WordPress", desc: "Custom websites and CMS solutions.", icon: "W" },
  { title: "Responsive Design", desc: "Mobile-first and clean layouts.", icon: "▣" },
  { title: "Figma", desc: "UI design, wireframes, and prototypes.", icon: "Fg" },
];

const projects = [
  {
    title: "Ota Pharm",
    desc: "Modern pharmacy delivering personalized healthcare services with trust and care.",
    tech: ["React", "Figma", "Responsive"],
    image: OtaPharm,
  },
  {
    title: "Innovation Hub",
    desc: "Interactive dashboard with modern design and clear data visuals.",
    tech: ["React", "Figma", "UI/UX", "Responsive"],
    image: Innohub,
    domain: "https://innohubit.com/",
  },
  {
    title: "AutoPark Lennestadt",
    desc: "Premium used cars, trusted service, elegant experience, and modern automotive excellence.",
    tech: ["React", "Figma", "Responsive", "FireBase", "SupaBase", "FramerMotion"],
    image: Dealer,
    domain: "https://autopark-lennestadt.de/",
  },
];

const timeline = [
  {
    title: "Started learning coding",
    company: "Innovation Academy",
    year: "2019 - Present",
    desc: "Started learning coding in Innovation Academy and building foundational developer skills.",
  },
  {
    title: "Finished Front End and started Backend",
    company: "Full Stack Learning",
    year: "2025 - Present",
    desc: "Finished frontend development studies and began backend learning to become a full stack developer.",
  },
  {
    title: "Started working at Innovation Hub",
    company: "Innovation Hub",
    year: "Jan 2026 - Present",
    desc: "Joined Innovation Hub in January 2026, working on real projects and growing my frontend skills.",
  },
  {
    title: "Started working at Majalab",
    company: "Majalab",
    year: "Mar 2026 - Present",
    desc: "Joined Majalab in March 2026 while continuing my work at Innovation Hub and Innovation Academy.",
  },
];

const Portfolio = () => {
  const form = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [emailIconAvailable, setEmailIconAvailable] = useState(true);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_exlooz9",
        "template_3hmf50l",
        form.current,
        "LpJ5icFAkQ89BOrLG"
      )
      .then(() => {
        alert("Message sent successfully");
        form.current.reset();
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        alert("Failed to send message");
      });
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="portfolio-page">
      <div className="background-glow glow-1"></div>
      <div className="background-glow glow-2"></div>
      <div className="background-grid"></div>

      <header className="navbar">
        <div className="logo">
          Leart <span>B.</span>
        </div>

        <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
          <a href="#home" onClick={closeMenu}>Home</a>
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#skills" onClick={closeMenu}>Skills</a>
          <a href="#projects" onClick={closeMenu}>Projects</a>
          <a href="#experience" onClick={closeMenu}>Experience</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
        </nav>

        <button
          className="menu-toggle"
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </header>

      <section className="hero section" id="home">
        <span className="hero-badge">Available for freelance work</span>

        <h1>
          Leart <span>B.</span>
        </h1>

        <h2>Front End Developer & Creative Builder</h2>

        <p>
          Crafting modern, clean, and responsive web experiences with React,
          WordPress, and creative UI design.
        </p>

        <div className="hero-buttons">
          <a href="#projects" className="btn btn-primary">
            View Projects
          </a>
          <a href="#contact" className="btn btn-secondary">
            Get In Touch
          </a>
        </div>

        <div className="social-icons">
          <a
            href="https://github.com/leartbivolaku0-wq"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>

          <a
            href="https://www.linkedin.com/in/leartbivolaku/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>

          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=leartbivolaku0@gmail.com&su=Client%20Interest"
            target="_blank"
            rel="noreferrer"
            aria-label="Email"
          >
            <MdEmail />
          </a>
        </div>
      </section>

      <section className="about section fade-section" id="about">
        <div className="about-text">
          <p className="section-label">ABOUT ME</p>

          <h2>
            Building the web,
            <br />
            <span>one pixel at a time</span>
          </h2>

          <p>
            I’m a passionate front end developer focused on building clean,
            modern, and user-friendly websites. I enjoy turning ideas into
            beautiful digital experiences.
          </p>

          <p>
            I work with React, WordPress, responsive design, and UI tools like
            Figma to create projects that look premium and feel smooth.
          </p>

          <div className="stats">
            <div>
              <h3>6+</h3>
              <span>Years Learning</span>
            </div>
            <div>
              <h3>13+</h3>
              <span>Projects</span>
            </div>
            <div>
              <h3>100%</h3>
              <span>Passion</span>
            </div>
          </div>
        </div>

        <div className="about-image-wrap">
          <img
            src={Leart}
            alt="Leart B."
            className="about-image"
          />
        </div>
      </section>

      <section className="skills section fade-section" id="skills">
        <p className="section-label center">SKILLS & EXPERTISE</p>
        <h2 className="section-title center">What I Work With</h2>
        <p className="section-subtitle center">
          A mix of code, design, and creativity to build strong digital experiences.
        </p>

        <div className="skills-grid">
          {skills.map((skill, index) => (
            <div className="skill-card" key={index}>
              <div className="skill-icon">{skill.icon}</div>
              <h3>{skill.title}</h3>
              <p>{skill.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="projects section fade-section" id="projects">
        <p className="section-label center">PORTFOLIO</p>
        <h2 className="section-title center">Featured Projects</h2>
        <p className="section-subtitle center">
          A selection of modern projects and creative work.
        </p>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div
              className="project-card"
              key={index}
              role={project.domain ? "link" : undefined}
              tabIndex={project.domain ? 0 : -1}
              onClick={() => {
                if (project.domain) {
                  window.open(project.domain, "_blank", "noopener,noreferrer");
                }
              }}
              onKeyDown={(event) => {
                if (project.domain && (event.key === "Enter" || event.key === " ")) {
                  window.open(project.domain, "_blank", "noopener,noreferrer");
                }
              }}
              style={{ cursor: project.domain ? "pointer" : "default" }}
            >
              <img
                src={project.image}
                alt={project.title}
                className="project-image"
              />

              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.desc}</p>

                <div className="project-tags">
                  {project.tech.map((item, i) => (
                    <span key={i}>{item}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="experience section fade-section" id="experience">
        <p className="section-label center">JOURNEY</p>
        <h2 className="section-title center">Experience & Education</h2>
        <p className="section-subtitle center">
          My path in tech and frontend development.
        </p>

        <div className="timeline">
          {timeline.map((item, index) => (
            <div className="timeline-item" key={index}>
              <div className="timeline-dot"></div>

              <div className="timeline-card">
                <div className="timeline-top">
                  <div>
                    <h3>{item.title}</h3>
                    <h4>{item.company}</h4>
                  </div>

                  <span>{item.year}</span>
                </div>

                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="contact section fade-section" id="contact">
        <p className="section-label center">GET IN TOUCH</p>
        <h2 className="section-title center">Let’s Work Together</h2>
        <p className="section-subtitle center contact-sub">
          Have a project in mind? Send me a message.
        </p>

        <div className="contact-grid">
          <div className="contact-info">
            <h3>Contact Information</h3>

            <div className="info-card">
              <strong>Email</strong>
              <p>leartbivolaku0@gmail.com</p>
            </div>

            <div className="info-card">
              <strong>Location</strong>
              <p>Vushtrri, Kosovo</p>
            </div>

            <h4>Follow Me</h4>

            <div className="social-icons left">
              <a
                href="https://github.com/leartbivolaku0-wq"
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>

              <a
                href="https://www.linkedin.com/in/leartbivolaku/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=leartbivolaku0@gmail.com&su=Client%20Interest"
                target="_blank"
                rel="noreferrer"
                aria-label="Email"
              >
                <MdEmail />
              </a>
            </div>

            <p className="contact-note">
              I’m open to frontend work, website projects, and creative collaborations.
            </p>
          </div>

          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <label htmlFor="user_name">Name</label>
            <input
              id="user_name"
              type="text"
              name="user_name"
              placeholder="Your name"
              required
            />

            <label htmlFor="user_email">Email</label>
            <input
              id="user_email"
              type="email"
              name="user_email"
              placeholder="your@email.com"
              required
            />

            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="6"
              placeholder="Your message..."
              required
            ></textarea>

            <button type="submit" className="btn btn-primary full">
              Send Message
            </button>
          </form>
        </div>
      </section>

      <footer className="footer">
        <p>© 2026 Leart B. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Portfolio;